import React from "react";
import { twMerge } from "tailwind-merge";

interface SpinnerProps {
  size?: "small" | "medium" | "large";
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = "medium",
}) => {
  const sizeClass = {
    small: "h-4 w-4",
    medium: "h-8 w-8",
    large: "h-16 w-16",
  };

  return (
    <div
      className={twMerge(
        sizeClass[size],
        "animate-spin rounded-full border-b-4 border-everglade",
      )}
    />
  );
};
